module.exports = __webpack_public_path__ + "img/full2-min.77444b95.png";